import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { TranslateModule } from "@ngx-translate/core";
import { NgxLoadingModule } from "ngx-loading";
import { FuseSharedModule } from "@fuse/shared.module";
import { LoanProcessorComponent } from "./loan-processor.component";
import { GooglePlaceModule } from "@yuvarajv/ngx-google-places-autocomplete";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";
const routes = [
    {
        path: "loan-processor",
        component: LoanProcessorComponent,
    },
];

@NgModule({
    declarations: [LoanProcessorComponent],
    imports: [
        RouterModule.forChild(routes),
        NgxLoadingModule.forRoot({}),
        TranslateModule,
        GooglePlaceModule,
        FuseSharedModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        NgxMaskPipe,
        NgxMaskDirective
    ],
    exports: [LoanProcessorComponent],
})
export class LoanProcessorModule {}
